import { axios } from "../lib";
import * as endpoints from "./apiEndpoints";

class ActivityService {
  static getAllActivity() {
    const url = `${endpoints.BASE_URL}${endpoints.ACTIVITY}`;
    return axios.get(url);
  }

  static clearAllActivity() {
    const url = `${endpoints.BASE_URL}${endpoints.ACTIVITY}`;
    return axios.delete(url);
  }
}

export default ActivityService;
